// SmartFeatureOverrides describes the Statsig `smart_feature_overrides` dynamic
// configuration.
export interface SmartFeatureOverrides {
  allow_model_training_on_shared_data?: boolean;
  enable_llm_powered_features?: boolean;
  share_ai_traces_with_wb?: boolean;
}

export const SMART_FEATURE_OVERRIDES_CONFIG_ID = 'smart_feature_overrides';

export function isSmartFeatureLocked(
  overrides: SmartFeatureOverrides | undefined,
  key: keyof SmartFeatureOverrides
): {locked: boolean; lockedValue: boolean | undefined} {
  const override = overrides?.[key];
  const locked = typeof override === 'boolean';
  return {locked, lockedValue: locked ? override : undefined};
}
